export default function TileServices() {
  const services = [
    {
      icon: 'ri-layout-grid-line',
      title: 'Floor Tile Installation',
      description: 'Expert installation of ceramic, porcelain, and natural stone flooring for kitchens, bathrooms, and living spaces.',
      features: ['Ceramic Tile', 'Porcelain Tile', 'Natural Stone', 'Heated Floors']
    },
    {
      icon: 'ri-grid-line',
      title: 'Backsplash Installation',
      description: 'Custom kitchen and bathroom backsplashes featuring glass, ceramic, and mosaic tile designs.',
      features: ['Glass Tile', 'Mosaic Patterns', 'Subway Tile', 'Custom Designs']
    },
    {
      icon: 'ri-drop-line',
      title: 'Shower & Tub Surrounds',
      description: 'Waterproof tile installations for showers and tubs with proper drainage and sealing.',
      features: ['Walk-In Showers', 'Tub Surrounds', 'Waterproofing', 'Custom Niches']
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Bathroom Remodeling',
      description: 'Complete bathroom transformations with tile floors, walls, and custom features.',
      features: ['Floor to Ceiling', 'Accent Walls', 'Vanity Surrounds', 'Modern Designs']
    },
    {
      icon: 'ri-tools-line',
      title: 'Tile Repair & Replacement',
      description: 'Professional repair services for cracked, loose, or damaged tiles with color matching.',
      features: ['Crack Repair', 'Grout Replacement', 'Tile Matching', 'Water Damage']
    },
    {
      icon: 'ri-sun-line',
      title: 'Outdoor Tile Installation',
      description: 'Durable outdoor tile solutions for patios, pool decks, and exterior living spaces.',
      features: ['Patio Tile', 'Pool Decks', 'Outdoor Kitchens', 'Weather Resistant']
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Professional Tile Installation Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From elegant bathroom remodels to stunning kitchen backsplashes, El Paso tile installers deliver expert craftsmanship for every project.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-teal-500 hover:shadow-xl transition-all">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6">
                <i className={`${service.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
